export default {
  props: {
    aiNoteObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // isBaiduMap: isBaiduMap(),
    };
  },
  computed: {
    conHeight() {
      const winWidth = window.innerWidth;
      const conHeight = 3 * winWidth / 4;
      if (conHeight) {
        return conHeight + 'px';
      }
      return 'auto';
    },
    defaultImg() {
      return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/default-feed.png';
    }
  },
  methods: {
    // 跳转到第三方
    goThird() {
      this.$emit('jump-url', this.aiNoteObj.jump_url);
    }
  }
};